export default {
	name: 'alarms-center',
	path: '/alarms-center',
	component: () => import('./pages/alarms-center/alarms-center-view.vue')
};
